import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

import { ref, reactive, getCurrentInstance, nextTick } from 'vue'
import { getUnionPackageListApi, savePackageApi } from '../../../apis/coupon-saas'
import { CouponType } from '../enum'

interface FormI { // 券包弹框数据
    id?: string,
    name: string,
    type: number | string,
    coupon_ids: any,
    amount:string,
    brand_name:string,
    moq:any
}
interface UnionPackageI { // 关联券包数据
    id: string,
    name: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PackageDialog',
  emits: ['reloadList'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const { proxy } = getCurrentInstance() as any

const formData = ref<FormI>({ // 券包弹框表单
    name: '',
    type: '',
    coupon_ids: '',
    amount:'',
    brand_name:'',
    moq:''
})
const unionPackageList = ref<UnionPackageI[]>([]) // 关联券包列表
const getUnionList = async () => {
    const { code, data, msg } = await getUnionPackageListApi({coupon_status: formData.value.type == 1 ? 0 : 1}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    unionPackageList.value = data
    let matchingCard = data.find(card => card.id == formData.value.coupon_ids);
    // 如果找到了匹配的对象，提取amount和brand_name属性
    if (matchingCard) {
        formData.value.amount = matchingCard.amount
        formData.value.brand_name = matchingCard.brand_name
    }
}
const moqNum = (val) => {
    if(val<=0) {
        return val=1;
    }
}
// 保存券包
const onSavePackage = () => {
    proxy.$refs['packageForm'].validate((valid:boolean) => {
        if (valid) {
            const { id, name, type, coupon_ids,amount,brand_name,moq } = formData.value
            savePackageApi({ id, name, type, ds_coupon_ids: coupon_ids,amount,brand_name,moq }).then((res:any) => {
                const { code, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '保存成功' })
                onDialogClose()
                emit('reloadList')
            })
        }
    })
}
// 关闭弹框，清空数据
const onDialogClose = () => {
    dialogShow.value = false
    proxy.$refs['packageForm'].resetFields()
}

const rules = reactive({
    name: [
        { required: true, message: '请输入券包名称', trigger: 'blur' }
    ],
    type: [
        { required: true, message: '请选择券包类型', trigger: 'change' }
    ],
    coupon_ids: [
        { required: true, message: '请选择关联券包', trigger: 'change' }
    ],
    amount: [
        { required: true, message: '请输入面值', trigger: 'blur' }
    ],
    brand_name: [
        { required: true, message: '请输入品牌', trigger: 'blur' }
    ],
    moq: [
        { required: true, message: '请输入起订量', trigger: 'blur' }
    ],
})

// 表单数据
const dialogShow = ref<boolean>(false) // 弹框状态
const unionIds = ref<any[]>([]) // 已关联券包ID

// 打开弹框
const openDialog = ({coupon_id = '', coupon_name = '', union_ids = [], coupon_status = ''}) => {
    dialogShow.value = true

    // 编辑进行反显
    formData.value.id = coupon_id
    formData.value.name = coupon_name
    formData.value.type = coupon_status
    formData.value.coupon_ids = union_ids[0]
    unionIds.value = union_ids

    if (coupon_status) {
        getUnionList()
    }

    nextTick(() => {
        // formData.value.coupon_ids = [...union_ids]
        proxy.$refs['packageForm'].clearValidate(['coupon_ids'])
    })
}

// 暴露方法
__expose({
    openDialog, // 打开弹框
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "添加券包",
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogShow).value = $event)),
    "before-close": onDialogClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: onDialogClose }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onSavePackage
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: formData.value,
        ref: "packageForm",
        "label-width": "100",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "券包名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入券包名称",
                maxlength: "50",
                disabled: Boolean(formData.value.id),
                clearable: ""
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "券包类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
                placeholder: "请选择券包类型",
                disabled: Boolean(formData.value.id),
                onChange: getUnionList
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "采购",
                    value: _unref(CouponType)['采购']
                  }, null, 8, ["value"]),
                  _createVNode(_component_el_option, {
                    label: "自制",
                    value: _unref(CouponType)['自制']
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "平台关联券包",
            prop: "coupon_ids"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.coupon_ids,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.coupon_ids) = $event)),
                placeholder: "请选择平台关联券包",
                filterable: "",
                clearable: "",
                onChange: getUnionList,
                disabled: unionIds.value.length > 0
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unionPackageList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: `${item.name}（${item.id}）`,
                      value: item.id,
                      disabled: unionIds.value.includes(item.id)
                    }, null, 8, ["label", "value", "disabled"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "面值",
            prop: "amount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.amount,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.amount) = $event)),
                modelModifiers: { trim: true },
                disabled: "",
                placeholder: "请输入面值",
                maxlength: "50",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "品牌",
            prop: "brand_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.brand_name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.brand_name) = $event)),
                modelModifiers: { trim: true },
                disabled: "",
                placeholder: "请输入品牌",
                maxlength: "50",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "起订量",
            prop: "moq"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.moq,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.moq) = $event)),
                modelModifiers: { trim: true },
                type: "number",
                min: 1,
                step: 1,
                onInput: _cache[6] || (_cache[6] = ($event: any) => (formData.value.moq <=0 || formData.value.moq.includes('.') ? formData.value.moq='':null)),
                title: moqNum(formData.value.moq) ? '起订量必须大于0且不可输入小数':'',
                placeholder: "请输入券起订量",
                maxlength: "50",
                clearable: ""
              }, null, 8, ["modelValue", "title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})